import { Component, OnInit } from '@angular/core';
import { faUser } from '@fortawesome/free-regular-svg-icons';
import { AuthService } from '../../../auth/services/auth.service';
import { constants } from 'projects/marketpro-ui/src/app/constants';
import {
  DataFilters,
  DataFiltersService,
} from '../../services/data-filters.service';
import { DashboardStatisticsService } from '../../services/dashboard-statistics.service';
import { CitiesService } from '../../services/cities.service';
import { UserFreemium } from '../../../auth/models/user.model';

@Component({
  selector: 'mpro-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss'],
})
export class TopBarComponent implements OnInit {
  public enableToggle: boolean;
  faUser = faUser;
  public isFreemium: boolean = false;
  public isOn: boolean = false;
  enableCategories(val: boolean) {
    this.authService.setCategoriesEnabled(val);
    this.isOn = val;
    this.authService.permissions$.subscribe((plan) => {
      this.isFreemium = plan.isFreemium;
      this.enableToggle = plan.categories !== undefined;
    });
    if (this.isOn) {
      this.dataFiltersService.resetLocation();
      this.citiesService.getCities$.next(undefined);
      return;
    }
    this.resetAll();
  }

  constructor(
    public authService: AuthService,
    public dataFiltersService: DataFiltersService,
    public dashboardService: DashboardStatisticsService,
    public citiesService: CitiesService
  ) {}

  ngOnInit(): void {
    this.isOn = false;
    this.enableCategories(false);
  }

  public resetAll() {
    this.dataFiltersService.setDataFilters({
      ...new DataFilters(),
      ...this.getAuthDataFilters(),
    });
  }

  private getAuthDataFilters(): Partial<DataFilters> {
    return new DataFilters();
  }

  openMarketingWebsite() {
    const userOpenToolModel: UserFreemium = JSON.parse(
      localStorage.getItem(constants.registeredUserOpenToolStorageKey)!
    );
    if (window.location.href.includes('dashboard')) {
      window.open(
        `https://worlddata.pro/contact-us/?first_name=${userOpenToolModel.firstName}&last_name=${userOpenToolModel.lastName}&company_name=${userOpenToolModel.organizationName}&company_email=${userOpenToolModel.email}`,
        '_blank'
      );
    } else {
      window.open(
        `https://staging.worlddata.pro/contact-us/?first_name=${userOpenToolModel.firstName}&last_name=${userOpenToolModel.lastName}&company_name=${userOpenToolModel.organizationName}&company_email=${userOpenToolModel.email}`,
        '_blank'
      );
    }
  }
}
